import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight, LayoutGrid, Map as MapIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { fetchAreas } from '../api';
import CommunitiesMap from '../components/CommunitiesMap';

const Areas = () => {
  const { t } = useApp();
  const [areas, setAreas] = useState([]);
  const [view, setView] = useState('grid');
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Best Areas to Buy Property in Dubai | GOBRA Capital Real Estate';
    fetchAreas().then(setAreas).catch(() => {});
  }, []);

  return (
    <main className="pt-24 md:pt-28">
      <div className="bg-gobra-slate py-12 md:py-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="h-1 w-12 bg-gobra-orange rounded-full mb-3" />
          <h1 className="font-title text-3xl md:text-5xl font-bold text-white">Best Areas to Buy Property in Dubai</h1>
          <p className="text-white/60 mt-3 max-w-2xl">Explore Dubai’s most sought-after communities. Each area brings together the finest launches from the city’s leading developers, hand-picked by GOBRA Capital.</p>
        </div>
      </div>

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-center justify-between gap-3 mb-8">
          <p className="text-sm text-muted-foreground">{areas.length} {areas.length === 1 ? 'community' : 'communities'}</p>
          <div className="inline-flex rounded-full border border-gobra-sand p-1 bg-white" data-testid="areas-view-toggle">
            <button
              type="button"
              onClick={() => setView('grid')}
              data-testid="areas-view-grid"
              className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${view === 'grid' ? 'bg-gobra-slate text-white' : 'text-gobra-slate hover:text-gobra-terracotta'}`}>
              <LayoutGrid className="h-4 w-4" /> Grid
            </button>
            <button
              type="button"
              onClick={() => setView('map')}
              data-testid="areas-view-map"
              className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${view === 'map' ? 'bg-gobra-slate text-white' : 'text-gobra-slate hover:text-gobra-terracotta'}`}>
              <MapIcon className="h-4 w-4" /> Map
            </button>
          </div>
        </div>

        {view === 'map' ? (
          <CommunitiesMap areas={areas} />
        ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {areas.map((a) => (
            <Link key={a.name} to={`/areas/${encodeURIComponent(a.name)}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] card-lift">
              <img src={a.image} alt={a.name} loading="lazy" className="h-full w-full object-cover img-zoom" />
              <div className="absolute inset-0 bg-gradient-to-t from-gobra-slate/95 via-gobra-slate/30 to-transparent" />
              <div className="absolute bottom-0 p-5 text-white">
                <div className="inline-flex items-center gap-1.5 text-gobra-orange text-xs font-semibold mb-1">
                  <MapPin className="h-3.5 w-3.5" /> {a.count} {a.count === 1 ? 'project' : 'projects'}
                </div>
                <h3 className="font-title text-2xl font-bold">{a.name}</h3>
                <p className="text-white/75 text-sm mt-1 line-clamp-2">{a.blurb}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm text-white/90 group-hover:text-gobra-orange transition-colors">
                  {t('explore_projects')} <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
        )}
      </section>
    </main>
  );
};

export default Areas;
